export default "__VITE_ASSET__DsnGZm5e__"